var map = {
	"./1_Cell_cover_story.jpg": "88dc",
	"./2_Nucleic_Acids_Research_cover.jpg": "58d6",
	"./3_Disease_models_and_mechanisms_cover.jpg": "0c75",
	"./5_Cell_cover.jpg": "bdc1",
	"./6_PNAS_cover.jpg": "6ff9",
	"./7_Stem_cell_reports_cover.jpg": "2309",
	"./8_International_journal_of_biological_sciences_cover.jpg": "d6f7",
	"./9_Science_cover.jpg": "0a3c",
	"./AASLD2024.jpg": "969d",
	"./AASLD2024.pdf": "d800",
	"./APVRS2026.png": "7d70",
	"./ARVO2026.pdf": "865a",
	"./ARVO2026.png": "3dbf",
	"./ASCPT2025.jpg": "8907",
	"./ASCPT2025.pdf": "7e6e",
	"./ASN2026.png": "80c8",
	"./EASL.jpg": "54cd",
	"./EASL2024.jpg": "070f",
	"./EASL2024.pdf": "c784",
	"./Hepatology202206.jpg": "5548",
	"./Hepatology202206_incert.jpg": "1fb5",
	"./IMMUNOLOGY2026.jpg": "6f7d",
	"./Nature_Biomedical_Engineering_2025.png": "0a7c",
	"./Nature_Biomedical_Engineering_Cover_Article.png": "48f2",
	"./Nature_Communications_2025.jpg": "28ac",
	"./Nature_Communications_2025.pdf": "b56e",
	"./bioRxiv_logo.png": "9e80",
	"./desktop_publications_top_img.jpg": "a00b",
	"./mobile_publications_img.jpg": "a472"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd1e";